import DESIGN_YOUR_BAG_CONSTANTS from './DesignYourBag.constants';

export const updateFormValues = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.UPDATE_FORM_VALUES,
  payload,
});

export const setFitValues = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_FIT_VALUES,
  payload,
});

export const loadDesignYourBag = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.LOAD_DESIGN_YOUR_BAG,
  payload,
});

export const setAlternateBrand = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_ALTERNATE_BRAND,
  payload,
});

export const setCurrentColorEntry = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_CURRENT_COLOR_ENTRY,
  payload,
});

export const setSizeList = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_SIZE_LIST,
  payload,
});

export const setIsUpdateRequire = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_IS_UPDATE_REQUIRED,
  payload,
});

export const setShowUpdateOrCancel = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_SHOW_UPDATE_OR_CANCEL,
  payload,
});

export const setProduct = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_PRODUCT,
  payload,
});

export const setFormName = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.SET_FORM_NAME,
  payload,
});

export const addProductToCollection = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.ADD_PRODUCT_TO_COLLECTION,
  payload,
});

export const resetDesignYourBagData = () => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.RESET_DESIGN_YOUR_BAG_DATA,
});

export const updateOrCancelProductInCollection = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.UPDATE_OR_CANCEL_PRODUCT_IN_COLLECTION,
  payload,
});

export const removeProductFromCollections = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.REMOVE_PRODUCT_FROM_COLLECTIONS,
  payload,
});

export const updateCollections = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.UPDATE_COLLECTIONS,
  payload,
});

export const increaseQuantityInCollections = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.INCREASE_QUANTITY_IN_COLLECTIONS,
  payload,
});

export const decreaseQuantityInCollections = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.DECREASE_QUANTITY_IN_COLLECTIONS,
  payload,
});

export const resetProductData = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.RESET_PRODUCT_DATA,
  payload,
});

export const addToCollection = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.ADD_ITEM_TO_COLLECTION,
  payload,
});

export const removeAddedProducts = (payload) => ({
  type: DESIGN_YOUR_BAG_CONSTANTS.REMOVE_ADDED_PRODUCTS,
  payload,
});
